/* Registrations.js */

"use strict";

module.exports = {
    DASHBOARD_SECTION: "App.GameConsole.Section.Dashboard"
};
Object.freeze(module.exports);
